const initialState = {
    lastLoginData: [],
    expiredPolicyData: null,
    reportMissingData: [],
    reportSourceData: [],
    reportCarrierData: [],
    reportQuoteData: [],
    raterReportData: [],
    lineOfBusinessData: {},
    quoteStatusData: null,
    policyReportData: {},
    taskReportData: null,
    missingPolicyData: null,
    customerReportData: null,
    filterReportMissingData: [],
    filterReportSourceData: [],
    filterReportCarrierData: [],
    filterReportQuoteData: [],
    filterReportZipData: [],
    reportLocationData: [],
    filterReportLocationData: [],
    error: null,
    get_production_report: [],
    get_task_status_report: [],
    zipcode_list: [],
     loading: false,
  error: null,
  success: false,
  };

  const reportReducer = (state = initialState, action) => {
    switch (action.type) {

      case 'LAST_LOGIN_DATA_SUCCESS':
        return {
          ...state,
          lastLoginData: action.payload,
          error: null,
        };

      case 'GET_ALL_PRODUCTION_REPORT_SUCCESS':
        return {
          ...state,
          get_production_report: action.payload,
          error: null,
        };

      case 'TASK_STATUS_DATA_SUCCESS':
        return {
          ...state,
          get_task_status_report: action.payload,
          error: null,
        };

  case 'GET_ZIP_CODE_SUCCESS':
        return {
          ...state,
          zipcode_list: action.payload,
          error: null,
        };

   case 'GET_SEARCH_PRODUCTION_REPORT_SUCCESS':
        return {
          ...state,
          get_production_report: action.payload,
          error: null,
        };

      case 'EXPIRED_POLICY_DATA_SUCCESS':
        return {
          ...state,
          expiredPolicyData: action.payload,
          error: null,
        };

      case 'PENDING_CANCELLATION_DATA_SUCCESS':
        return {
          ...state,
          pendingCancellationData: action.payload,
          error: null,
        };

        case 'LEAD_SOURCE_REPORT_DATA_SUCCESS':
        return {
          ...state,
          leadSourceReportData: action.payload,
          error: null,
        };

         case 'RENEWAL_REPORT_DATA_SUCCESS':
        return {
          ...state,
          renewalReportData: action.payload,
          error: null,
        };


        case 'PENDING_CANCELLATION_DATA_FAILURE':
         case 'LEAD_SOURCE_REPORT_DATA_FAILURE':
        case 'RENEWAL_REPORT_DATA_FAILURE':
      case 'GET_REPORT_MISSING_DOCUMENT_SUCCESS':
        return {
        ...state, reportMissingData: action.payload, error: null};

      case 'GET_REPORT_SOURCE_SUCCESS':
        return {
        ...state, reportSourceData: action.payload, error: null};

      case 'GET_REPORT_CARRIER_NAME_SUCCESS':
        return {
        ...state, reportCarrierData: action.payload, error: null};

      case 'GET_REPORT_QUOTE_TYPE_SUCCESS':
        return {
        ...state, reportQuoteData: action.payload, error: null};

      case 'SEARCH_RATER_REPORT_SUCCESS':
        return {
        ...state, raterReportData: action.payload, error: null};
       case 'RESET_RATER_REPORT':
        return {
        ...state, raterReportData: action.payload, error: null};

        case 'LINE_OF_BUSINESS_DATA_SUCCESS':
        return {
          ...state,
          lineOfBusinessData: action.payload,
          error: null,
        };

        case 'QUOTE_STATUS_DATA_SUCCESS':
            return {
              ...state,
              quoteStatusData: action.payload,
              error: null,
            };

        case 'POLICY_REPORT_DATA_SUCCESS':
        return {
          ...state,
          policyReportData: action.payload,
          error: null,
        };

        case 'TASK_REPORT_DATA_SUCCESS':
        return {
          ...state,
          taskReportData: action.payload,
          error: null,
        };

        case 'MISSING_POLICY_DATA_SUCCESS':
        return {
          ...state,
          missingPolicyData: action.payload,
          error: null,
        };

        case 'CUSTOMER_REPORT_DATA_SUCCESS':
        return {
          ...state,
          customerReportData: action.payload,
          error: null,
        };

      case 'FILTER_REPORT_MISSING_DOCUMENT_SUCCESS':
        return {
        ...state, filterReportMissingData: action.payload, error: null};

      case 'FILTER_REPORT_SOURCE_SUCCESS':
        return {
        ...state, filterReportSourceData: action.payload, error: null};

      case 'FILTER_REPORT_CARRIER_NAME_SUCCESS':
        return {
        ...state, filterReportCarrierData: action.payload, error: null};

      case 'FILTER_REPORT_QUOTE_TYPE_SUCCESS':
        return {
        ...state, filterReportQuoteData: action.payload, error: null};

      case 'FILTER_REPORT_ZIP_CODE_SUCCESS':
        return {
        ...state, filterReportZipData: action.payload, error: null};

      case 'GET_REPORT_LOCATION_GROUP_SUCCESS':
        return {
        ...state, reportLocationData: action.payload, error: null};

      case 'FILTER_REPORT_LOCATION_GROUP_SUCCESS':
        return {
        ...state, filterReportLocationData: action.payload, error: null};

      case 'EXPORT_REPORT_REQUEST':
       return { ...state, loading: true, error: null, success: false };
      case 'EXPORT_REPORT_SUCCESS':
        return { ...state, loading: false, success: true };

        case 'EXPORT_REPORT_FAILURE':
        case 'CUSTOMER_REPORT_DATA_FAILURE':
        case 'MISSING_POLICY_DATA_FAILURE':
        case 'TASK_REPORT_DATA_FAILURE':
        case 'POLICY_REPORT_DATA_FAILURE':
        case 'QUOTE_STATUS_DATA_FAILURE':
        case 'LINE_OF_BUSINESS_DATA_FAILURE':
        case 'LAST_LOGIN_DATA_FAILURE':
        case 'EXPIRED_POLICY_DATA_FAILURE':
        case 'GET_REPORT_MISSING_DOCUMENT_FAILURE':
        case 'GET_REPORT_SOURCE_FAILURE':
        case 'GET_REPORT_CARRIER_NAME_FAILURE':
        case 'GET_REPORT_QUOTE_TYPE_FAILURE':
        case 'GET_REPORT_ZIP_CODE_FAILURE':
        case 'FILTER_REPORT_MISSING_DOCUMENT_FAILURE':
        case 'FILTER_REPORT_SOURCE_FAILURE':
        case 'FILTER_REPORT_CARRIER_NAME_FAILURE':
        case 'FILTER_REPORT_QUOTE_TYPE_FAILURE':
        case 'FILTER_REPORT_ZIP_CODE_FAILURE':
        case 'GET_REPORT_LOCATION_GROUP_FAILURE':
        case 'FILTER_REPORT_LOCATION_GROUP_FAILURE':
        case 'TASK_STATUS_DATA_FAILURE':
      return { ...state, error: action.payload };
      default:
      return state;
    }
  };

  export default reportReducer;
